import { Field } from './Field';
import { SearchVisibility } from './SearchVisibility';
import { SingleTextField } from './SingleTextField';
import { SingleFullTextField } from './SingleFullTextField';
import { MultiTextField } from './MultiTextField';
import { MultiFullTextField } from './MultiFullTextField';
import { MultiTagField } from './MultiTagField';
import { MultiNamedEntityField } from './MultiNamedEntityField';
import { MultiCollectionField } from './MultiCollectionField';
import { MultiSearchTermField } from './MultiSearchTermField';
import { NumberRangeField } from './NumberRangeField';
import { DateRangeField } from './DateRangeField';
import { SingleBooleanField } from './SingleBooleanField';
import { BatesRangeField } from './BatesRangeField';

export enum Operator {
  And,
  Or
}

export class SearchExpression {
  public operator: Operator;
  public fields: Field[];
  public searchExpressions: SearchExpression[];

  constructor() {
    this.operator = Operator.And;
    this.fields = [];
    this.searchExpressions = [];
  }

  public static From(expression): SearchExpression {
    let searchExpression = new SearchExpression();
    let copyFields = (source, destination) => {
      source.fields.forEach(f => {
        switch (f.__className) {
          case SingleTextField.typeName():
            destination.fields.push(new SingleTextField(f.name, f.description, f.value, f.comparisonType));
            break;
          case SingleFullTextField.typeName():
            destination.fields.push(new SingleFullTextField(f.name, f.description, f.value, f.comparisonType));
            break;
          case MultiTextField.typeName():
            destination.fields.push(new MultiTextField(f.name, f.description, f.values, f.comparisonType));
            break;
          case MultiFullTextField.typeName():
            destination.fields.push(new MultiFullTextField(f.name, f.description, f.values, f.comparisonType));
            break;
          case MultiTagField.typeName():
            destination.fields.push(new MultiTagField(f.name, f.description, f.values, f.comparisonType));
            break;
          case MultiNamedEntityField.typeName():
            f.values?.forEach(v => v.name = v.id);
            destination.fields.push(new MultiNamedEntityField(f.name, f.description, f.values, f.comparisonType, f.resourceEntityType));
            break;
          case MultiCollectionField.typeName():
            destination.fields.push(new MultiCollectionField(f.name, f.description, f.values, f.comparisonType));
            break;
          case MultiSearchTermField.typeName():
            destination.fields.push(new MultiSearchTermField(f.name, f.description, f.values, f.comparisonType, f.searchTermList));
            break;
          case NumberRangeField.typeName():
            destination.fields.push(new NumberRangeField(f.name, f.description, f.factor, f.begin, f.end, f.comparisonType));
            break;
          case DateRangeField.typeName():
            destination.fields.push(new DateRangeField(f.name, f.description, f.begin, f.end, f.comparisonType));
            break;
          case SingleBooleanField.typeName():
            destination.fields.push(new SingleBooleanField(f.name, f.description, f.value, f.comparisonType));
            break;
          case BatesRangeField.typeName():
            destination.fields.push(new BatesRangeField(f.name, f.description, f.begin, f.end, f.comparisonType));
            break;
        }
      });
    };

    let copyExpressions = (source, destination) => {
      destination.operator = source.operator;
      copyFields(source, destination);

      source.searchExpressions.forEach(s => {
        let searchExpression = new SearchExpression();
        destination.searchExpressions.push(searchExpression);
        copyExpressions(s, searchExpression);
      });
    };

    copyExpressions(expression, searchExpression);

    return searchExpression;
  }

  public toString() {
    return "";
  }
}
// Expose as browser global so cross-module bare references in namespace files resolve
(window as any).SearchExpression = SearchExpression;
